import { useTranslation } from 'react-i18next';

import { CourseAdminCard } from '@/components/shared/CourseAdminCard';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import CoursePath from '@/models/CoursePath';
import { canDeleteCoursePath } from '@/utils/course-path/canDeleteCoursePath';

type PedContentMoreActionsProps = {
  coursePath: CoursePath;
  onCreateVersion?: (coursePath: CoursePath) => void;
  onCreateEdition?: (coursePath: CoursePath) => void;
  onDelete?: (slug: string) => void;
};

export default function PedContentMoreActions({
  coursePath,
  onCreateVersion,
  onCreateEdition,
  onDelete,
}: PedContentMoreActionsProps) {
  const { t } = useTranslation('translation');

  const canDelete = canDeleteCoursePath({ coursePath });

  const isPublished = coursePath.status === VersioningStatusEnum.PUBLISHED;

  const isBeta = coursePath.status === VersioningStatusEnum.BETA;

  const showMoreActions = canDelete || isPublished || isBeta;

  return (
    <ConditionalRenderer condition={showMoreActions}>
      <CourseAdminCard.MoreActions>
        {onCreateVersion && isPublished && (
          <CourseAdminCard.MoreActions.Versioning
            onClick={() => onCreateVersion(coursePath)}
          />
        )}
        {onCreateVersion && isBeta && (
          <CourseAdminCard.MoreActions.Versioning
            onClick={() => onCreateVersion(coursePath)}
            text={t('common.backToVersioning')}
          />
        )}
        {onCreateEdition && isPublished && (
          <CourseAdminCard.MoreActions.Edition
            onClick={() => onCreateEdition(coursePath)}
          />
        )}
        {onDelete && canDelete && (
          <CourseAdminCard.MoreActions.Delete
            onClick={() => onDelete(coursePath.slug)}
            text={t('common.discardVersion')}
            confirm
          />
        )}
      </CourseAdminCard.MoreActions>
    </ConditionalRenderer>
  );
}
